'use client';

import { c as _c } from "react/compiler-runtime";
import { LDProvider, reactSdkContextFactory } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
export const flagsContext = reactSdkContextFactory();
export const LaunchDarklyProvider = props => {
  const $ = _c(21);
  const {
    isDev,
    isDemo
  } = useEnvironment();
  const {
    currentProjectId,
    user
  } = useUser();
  if (!currentProjectId) {
    return props.children;
  }
  if (isDemo || isDev) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        flags: {
          NonCognitoEonAccounts: false,
          SkipOnboarding: false,
          dlsgFrontend: true,
          assistantEnabled: false,
          LlgFrontend: true,
          CostExplorerOverview: false,
          DeleteRestoreAccountEnabled: true,
          enableHourlyBackup: false,
          AzureSqlVirtualMachineSupport: true,
          ownCustomerOnboardingEnabled: false,
          byovEnabled: true,
          hourlyDlsgPolicyEnabled: false,
          dynamoAdvancedRestoreFlowEnabled: true,
          OnboardTenantAgainEnabled: true,
          GcpRestoreOrgAndFolderSupport: false,
          SapHanaPitrSupport: true,
          MongoAtlasSupport: true,
          ExploreFilesForDatabaseVms: true,
          RdsRestoreWithoutEncryptionEnabled: false,
          RecordRestoreResultsEnabled: true,
          EC2HighFrequencyBackupEnabled: true,
          RdsHighFrequencyBackupEnabled: true,
          RoleBackupPoliciesConfig: true,
          RoleRestoreAccountAccessCondition: true,
          EnableAzureVaultNetworkIsolation: true,
          AzureBackupVaultCmkSupport: true,
          EnableCrossCloudBackup: true,
          AzureSnapshotsDiscoverySupport: true,
          terraformAzureOnboarding: true,
          AwsSelectiveOnboarding: true,
          SkipOrgUnitInvokeDiscovery: true,
          FSxSupport: true,
          AwsRedshiftDiscoverySupport: true,
          AwsRedshiftNativeBackupSupport: true,
          AwsDocumentDbSupport: true,
          NeptuneBackupSupport: true,
          AzureMultipleAppRegistrations: false,
          AzureCustomPermissionsModel: false,
          consolidateOnboardingExperienceShouldIncludeInteractive: false,
          displayJobSteps: false,
          isServiceNowNotificationEnabled: true,
          AuroraGlobalDbDiscoverySupport: true,
          EnableCrossRegionOfflineRestore: true,
          EnableMrapForByov: true,
          BigQueryNativeRestoreEnabled: true,
          EnableBigQueryNativePolicy: true,
          EnableAirGappedVault: true,
          SensitivityAnnotations: true,
          RdsRestorePreserveOriginalMemberNames: false,
          AwsKeyspacesSupport: true,
          RdsCdcUiEnabled: true,
          AiAgents: false,
          EnableRDSRestorePasswordManagement: true,
          Ec2VolumeBackupExclusionEnabled: true,
          ZeroEtlUiEnabled: true,
          EnableExportAccessDeniedItems: true
        },
        flagKeyMap: {},
        ldClient: undefined
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== props.children) {
      t1 = <flagsContext.Provider value={t0}>{props.children}</flagsContext.Provider>;
      $[1] = props.children;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (!props.clientId || !user) {
    return props.children;
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      reactContext: flagsContext,
      useCamelCaseFlagKeys: false
    };
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== currentProjectId || $[5] !== user.eonAccount.domain || $[6] !== user.eonAccount.name) {
    t1 = {
      key: currentProjectId,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain
    };
    $[4] = currentProjectId;
    $[5] = user.eonAccount.domain;
    $[6] = user.eonAccount.name;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== currentProjectId || $[9] !== user.eonAccount.domain || $[10] !== user.eonAccount.id || $[11] !== user.eonAccount.name) {
    t2 = {
      key: user.eonAccount.id,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain,
      projectId: currentProjectId
    };
    $[8] = currentProjectId;
    $[9] = user.eonAccount.domain;
    $[10] = user.eonAccount.id;
    $[11] = user.eonAccount.name;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = {
      kind: "multi",
      user: t1,
      organization: t2
    };
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== props.children || $[18] !== props.clientId || $[19] !== t3) {
    t5 = <LDProvider reactOptions={t0} clientSideID={props.clientId} context={t3} options={t4}>{props.children}</LDProvider>;
    $[17] = props.children;
    $[18] = props.clientId;
    $[19] = t3;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};